import React from "react";

function Stat({ label, value, accent, testid }) {
  return (
    <div
      data-testid={testid}
      className="border border-zinc-800 bg-zinc-950 px-5 py-4 flex flex-col gap-1"
    >
      <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
        {label}
      </span>
      <span
        className={`font-mono text-2xl font-semibold tabular-nums ${
          accent || "text-zinc-100"
        }`}
      >
        {value}
      </span>
    </div>
  );
}

export default function StatsRow({ stats }) {
  if (!stats) return null;
  const topAgency = stats.by_agency?.[0]?.label ?? "—";
  const topCountry = stats.by_country?.[0]?.label ?? "—";
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-0 border-b border-zinc-800">
      <Stat
        label="Total Records"
        value={String(stats.total).padStart(3, "0")}
        testid="stat-total"
      />
      <Stat
        label="Unresolved"
        value={String(stats.unresolved).padStart(3, "0")}
        accent="text-amber-400"
        testid="stat-unresolved"
      />
      <Stat
        label="Resolved"
        value={String(stats.resolved).padStart(3, "0")}
        accent="text-emerald-400"
        testid="stat-resolved"
      />
      <Stat label="Top Reporting Agency" value={topAgency} testid="stat-top-agency" />
      <Stat label="Top Origin" value={topCountry} testid="stat-top-country" />
    </div>
  );
}
